import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement } from "react";
import {
	AnnouncementNotificationDataViewModel,
	AnnouncementReactionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type AnnouncementActivityInvocationProps = {
	data: AnnouncementNotificationDataViewModel
		| AnnouncementReactionNotificationDataViewModel;
	onDismiss: () => void;
};

export const AnnouncementActivityInvocation = (props: AnnouncementActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		announcementId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.Announcement}
			id={announcementId}
			onClose={onDismiss}
		/>
	);
};

AnnouncementActivityInvocation.displayName = "AnnouncementActivityInvocation";